import { ItemTabs } from 'CMFW/layout/ItemTabs';
import { ModuleContainer } from 'components/common/styles';
import React from 'react';
import LanguagesTab from './LanguagesTab';
import DialectsTab from './DialectsTab';

const Languages: React.FC = () => {
  return (
    <ModuleContainer>
      <ItemTabs tabNames={['Languages', 'Dialects']}>
        <LanguagesTab />
        <DialectsTab />
      </ItemTabs>
    </ModuleContainer>
  );
};

export default Languages;
